/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {SubscriptionResourceService} from "@well/resource-services";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsListService {

  constructor(private subscriptionResourceService: SubscriptionResourceService) { }

  getLegalEntitiesForSubscriptionType(subscriptionTypeUuid: string) {
    return this.subscriptionResourceService.getLegalEntitiesForSubscriptionType(subscriptionTypeUuid)
  }
}
